/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { PURGE } from 'redux-persist';

export interface AccordionDetails {
  componentId: string;
  isOpen: boolean;
}

export interface AccordionState {
  accordions: AccordionDetails[];
}

const initialState: AccordionState = {
  accordions: []
};

const accordionSlice = createSlice({
  name: 'accordions',
  initialState,
  reducers: {
    triggerAccordion: (
      state,
      {
        payload: { componentId }
      }: PayloadAction<{
        componentId: string;
      }>
    ) => {
      const accordion = state.accordions.find(
        (accordion) => accordion.componentId === componentId
      );

      if (!accordion) {
        state.accordions.push({
          componentId,
          isOpen: true
        });
      } else {
        accordion.isOpen = !accordion.isOpen;
      }
    },
    openAccordion: (
      state,
      {
        payload: { componentId }
      }: PayloadAction<{
        componentId: string;
      }>
    ) => {
      const accordion = state.accordions.find(
        (accordion) => accordion.componentId === componentId
      );

      if (!accordion) {
        state.accordions.push({
          componentId,
          isOpen: true
        });
      } else {
        accordion.isOpen = true;
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

export const selectAccordion = createSelector(
  (state: RootState) => state.accordions,
  (state: RootState, componentId: string) => componentId,
  (state, componentId) => {
    const accordion = state.accordions.find(
      (accordion) => accordion.componentId === componentId
    );

    return {
      isOpen: accordion?.isOpen ?? false
    };
  }
);

export const areAnyAccordionsOpen = createSelector(
  (state: RootState) => state.accordions,
  (state: RootState, accordionIds: string[]) => accordionIds,
  (state, accordionIds) => {
    return state.accordions.some(
      (accordion) =>
        accordionIds.includes(accordion.componentId) && accordion.isOpen
    );
  }
);

export const { triggerAccordion, openAccordion } = accordionSlice.actions;

export default accordionSlice.reducer;
